// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saltTabNextPanel{width:100%;height:100%}.saltTabNextPanel[hidden]{display:none}.saltTabNextPanel:focus-visible{outline:var(--salt-focused-outline)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
